var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view login"},[(_vm.loading)?_c('loader'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(!_vm.loading)?void 0:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }